import { useParsedCookie } from "~/lib/hooks";

export const useSCMPExperimentCookie = () => {
  const { value, ...attributes } = useParsedCookie("scmp_exp_10005_variant", raw => raw, {
    initializeWithValue: true,
  });

  return {
    ...attributes,
    value: value ?? "b",
  };
};
